// extracted by mini-css-extract-plugin
export default {"warning":"styles_warning__qymgz","warningText":"styles_warningText__xZ5w6","spin":"styles_spin__W6ITY"};